import React from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Box } from '@mui/material';

const NoOrdersIllustration = ({ style }) => (
  <Box sx={{ position: 'relative', width: 80, height: 80, ...style }}>
    <InsertDriveFileOutlinedIcon sx={{ fontSize: 64, color: '#B0BEC5', position: 'absolute', left: 8, top: 8 }} />
    <SearchOutlinedIcon sx={{ fontSize: 36, color: '#26C6DA', position: 'absolute', right: 0, bottom: 0, background: '#fff', borderRadius: '50%' }} />
  </Box>
);

export default NoOrdersIllustration; 